module.exports = __webpack_public_path__ + "images/emoji/clock1230.fb854b7594d5c84d8765.png";